export var PassType;

(function (PassType) {
  PassType["Normal"] = "normal";
  PassType["PostProcessing"] = "post-processing";
})(PassType || (PassType = {}));
//# sourceMappingURL=IMultiPassRenderer.js.map